import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import Button from 'src/components/Button';

const FiltersWrapper = styled('div')`
  flex-basis: 100%;
  display: flex;
  position: relative;
  align-items: center;
  margin-top: 20px;
`;

const FiltersLabel = styled('div')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: normal;
  color: var(--ph-gray-500);
`;

const MoreButton = styled('div')`
  transition: var(--ph-button-transition);
  font-family: var(--ph-font-family-franklin-medium-regular);
  font-size: var(--ph-text-sm);
  background-color: var(--transparent);
  color: var(--ph-gray-500);
  border-radius: var(--ph-border-radius-sm);
  display: inline-flex;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: manipulation;
  text-transform: none;
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.2;
  outline: none;
  padding-left: 12px;
  padding-right: 12px;
  height: 32px;
  min-width: 32px;
  border: 0;
  cursor: pointer;
  margin-left: 15px;

  &:hover {
    background-color: var(--ph-gray-25);
    color: var(--ph-gray-700);
  }

  &:active {
    background-color: var(--ph-gray-50);
    color: var(--ph-gray-700);
  }

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }
`;

const MorePopup = styled('div')`
  position: absolute;
  left: 0;
  top: 35px;
  width: 230px;
  overflow: hidden;
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--white);
  box-shadow: var(--ph-box-shadow-sm);
  cursor: default;

  &.list {
    label {
      background-color: transparent;
      border-radius: 0;
      padding: 0 0 0 28px;
      margin: 0 0 15px 0;
      color: var(--black);
    }

    label[class*='textField'] {
      padding: 0;
      margin: 0;
    }

    span {
      height: 16px;
      width: 16px;
      border-radius: var(--ph-border-radius-xs);
      border: 2px solid var(--ph-light-blue-500);
      background-color: var(--white);

      &::before {
        top: 0 !important;
        left: 1px !important;
        background:
          svg-load('../../Svg/icons/checkbox.svg', fill=#29a9e0) 0 center
          no-repeat;
      }
    }
  }

  &.date {
    padding: 10px;
    width: 300px;
    overflow: visible;

    label {
      border: 0;
      min-height: 36px;
    }

    div[class*='datePickerFieldLabel'] {
      flex: 0 0 77px;
      min-width: 77px;
      border: 0;
      padding: 10px 20px;
    }

    label + label {
      margin-top: 10px;
    }

    input {
      min-height: 36px;
      background-color: var(--white);
      border-radius: var(--ph-border-radius-sm);
    }

    div[class*='date-icon-div'] {
      path,
      rect {
        stroke: var(--ph-gray-500);
      }
    }
  }
`;

const MoreSearch = styled('div')`
  position: relative;
  padding: 10px;

  label {
    margin: 0;
    padding: 0;
    border: 0;
  }

  input {
    background-color: var(--white);
    color: var(--black);
  }
`;

const PopupTextField = styled('div')`
  position: relative;
  margin: 8px;

  label {
    margin: 0;
    padding: 0;
    border: 0;
    min-height: 36px;
  }

  input {
    background-color: var(--white);
    color: var(--black);

    &::placeholder {
      font-size: var(--ph-text-sm);
      font-weight: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: var(--ph-gray-500);
    }
  }
`;

const MoreSearchIcon = styled(Svg)`
  position: absolute;
  left: 50%;
  right: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20px;

  path {
    fill: var(--ph-gray-500);
  }

  &.funnel {
    width: 12px;
  }

  &.search {
    right: 3px;
    top: 16px;
  }

  &.check {
    width: 12px;

    polyline {
      stroke: var(--white);
    }
  }
`;

const TextConfirmButton = styled(Button)`
  position: absolute;
  right: 5px;
  top: 3px;
  width: 24px;
  height: 24px;
  min-width: 0;
  padding: 0;

  &:hover {
    background-color: var(--ph-orange-700);
  }

  &:active {
    background-color: var(--ph-orange-900);
  }

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }

`;

const MoreContent = styled('div')`
  max-height: 200px;
  overflow-y: auto;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
`;

const MoreContentItem = styled('div')`
  transition: var(--ph-transition);
  font-family: var(--ph-font-family);
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 35px;
  letter-spacing: normal;
  color: var(--black);
  cursor: pointer;
  padding: 0 10px;

  &:hover {
    border-radius: var(--ph-border-radius-sm);
    background-color: rgba(var(--ph-gray-rgb-50), 0.8);
  }

`;

const FilterWrapper = styled('div')`
  position: relative;
  margin-left: 15px;
`;

const FilterLabel = styled('div')`
  border-radius: var(--ph-border-radius-md);
  background-color: var(--ph-light-blue-500);
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--white);
  cursor: pointer;
  padding: 5px 30px 5px 10px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const FilterRemoveBtn = styled(Svg)`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translate(0%, -50%);
  width: 10px;
  cursor: pointer;

  path {
    fill: var(--white);
  }
`;

const ButtonsRow = styled('div')`
  margin: 20px 20px;

  button {
    padding: 5px 10px;
    min-width: 100px;
    border-radius: var(--ph-border-radius-sm) !important;
  }

  button + button {
    margin-left: 20px !important;
    border-bottom: 0 !important;
  }
`;

const DeletedBlock = styled('div')`
  transition: var(--ph-button-transition);
  font-family: var(--ph-font-family-franklin-medium-regular);
  color: var(--ph-gray-500);
  background-color: var(--ph-gray-50);
  border-radius: var(--ph-border-radius-sm);
  display: inline-flex;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: manipulation;
  text-transform: none;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.2;
  outline: none;
  font-size: var(--ph-text-sm);
  padding-left: 12px;
  padding-right: 12px;
  height: 32px;
  min-width: 32px;
  border: 0;
  cursor: pointer;
  position: absolute;
  right: 0;

  &.selected {
    path {
      fill: var(--ph-gray-500);
    }
  }

  &:hover {
    background-color: var(--ph-gray-100);
    color: var(--ph-gray-700);

    path {
      fill: var(--ph-gray-700);
    }
  }

  &:active {
    background-color: var(--ph-gray-200);
    color: var(--ph-gray-800);
  }

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }

`;

const DeletedIconWrapper = styled('div')`
  display: inline-block;
  border-radius: var(--ph-border-radius-sm);
  margin-left: 15px;
  position: relative;
  top: 0;
`;

const DeletedIcon = styled(Svg)`
  width: 16px;
  height: 16px;
`;

const DateLinks = styled('div')`
  margin-bottom: 10px;
`;

const DateLink = styled('div')`
  transition: var(--ph-transition);
  height: 30px;
  vertical-align: middle;
  line-height: 30px;
  color: var(--ph-black);
  margin: 0;
  font-size: var(--ph-text-sm);
  cursor: pointer;
  padding: 0 5px;

  &:hover {
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-gray-50);
  }
`;

export default {
  FiltersWrapper,
  FiltersLabel,
  MoreButton,
  MorePopup,
  MoreSearch,
  PopupTextField,
  MoreSearchIcon,
  MoreContent,
  MoreContentItem,
  FilterWrapper,
  FilterLabel,
  FilterRemoveBtn,
  TextConfirmButton,
  ButtonsRow,
  DeletedBlock,
  DeletedIconWrapper,
  DeletedIcon,
  DateLinks,
  DateLink,
};
